import { ChatHeader } from '@/components/SearchAssistant/components/ChatHeader';
import { ChatInputWrapper } from '@/components/SearchAssistant/components/ChatInput';
import { ErrorBoundary } from '@/components/SearchAssistant/components/ErrorBoundary';
import { Messages } from '@/components/SearchAssistant/components/Messages';
import { useChatSetup } from '@/components/SearchAssistant/hooks/useChatData';
import { Box } from '@mui/material';

const styles = {
  chatWrapper: {
    position: 'relative',
    zIndex: 20,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRadius: '0.25rem',
    overflow: 'hidden',
  },
};

const SyncData = () => {
  useChatSetup();
  return null;
};

export const ChatContent = () => {
  return (
    <Box sx={styles.chatWrapper}>
      <ChatHeader />
      <ErrorBoundary>
        <SyncData />
        <Messages />
        <ChatInputWrapper />
      </ErrorBoundary>
    </Box>
  );
};
